import React from 'react';
import './About.css';

const PrivacyPolicy = () => {
  return (
    <div className="about-page">
      <div className="page-hero" style={{
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
      }}>
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Your privacy is important to us</p>
        </div>
      </div>

      <div className="container section">
        <div className="content-card">
          <p className="last-updated">Last Updated: October 15, 2025</p>

          <section className="policy-section">
            <h2>1. Information We Collect</h2>
            <p>We collect personal information (name, email, phone), payment details, travel preferences, and technical data for booking and service purposes.</p>
          </section>

          <section className="policy-section">
            <h2>2. How We Use Your Information</h2>
            <p>Your information is used for processing bookings, providing customer support, sending travel documents, and improving our services.</p>
          </section>

          <section className="policy-section">
            <h2>3. Information Sharing</h2>
            <p>We share information only with service providers (airlines, hotels), payment processors, and when legally required. <strong>We never sell your data.</strong></p>
          </section>

          <section className="policy-section">
            <h2>4. Data Security</h2>
            <p>We use SSL encryption, secure servers, and regular security audits to protect your data.</p>
          </section>

          <section className="policy-section">
            <h2>5. Your Rights</h2>
            <p>You can access, update, or delete your personal information by contacting us.</p>
          </section>

          <section className="policy-section">
            <h2>6. Contact</h2>
            <p>For privacy concerns, contact us at syedabuzar626@gmail.com or +91 9731395805</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
